import React, { useEffect, useState } from 'react';
import './buynow.css';
import gif from '../annimation/verified.gif';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import { useCart, useDispatchCart } from '../contextreducer/ContextReducer';
import { BASE_URL } from '../helper';

export default function ConfirmOrder() {

    const data = useCart(); // Get the state from the context
    const dispatch = useDispatchCart()

    const navigate = useNavigate()
    const [order, setOrder] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const handleOrderConfirm = async () => {
        let userEmail = localStorage.getItem("userEmail");
        // const addressID = data[0].addressId;
        // console.log(data,localStorage.getItem("userEmail"),new Date())
        let response = await fetch(`${BASE_URL}/api/orderdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                order_data: data,
                email: userEmail,
            })
        });
        console.log("JSON RESPONSE:::::", response.status)
        if (response.status === 200) {
            dispatch({ type: "DROP" })
            setOrder(true);
            setIsLoading(true)
        }
    }

    const handleViewOrder = () => {
        navigate('/order')
    }

    useEffect(() => {
        // Simulating an asynchronous data fetch
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }, [isLoading]);

    if (isLoading) {
        return (
            <div className="cart_section">
                <div className="circle">
                    <CircularProgress />
                    <h2>Loading....</h2>
                </div>
            </div>
        );
    }

    return (
        <div className="buynow_section">
            <div className="buynow_container" style={{ textAlign: 'center' }}>
                <div className="left_buy">
                    <p className={`place_oder ${order ? 'order_confirm' : ''}`}>click on </p>
                    <button
                        className={`place_oder_btn ${order ? 'order_confirm' : ''}`}
                        onClick={handleOrderConfirm}>
                        Order Confirm
                    </button>
                    {order ? (
                        <div className='verified' >
                            <img style={{ width: "300px" }} src={gif} speed="2" alt="Verified" /><br />
                            <button className='place_oder_btn' onClick={handleViewOrder}>View order</button>
                        </div>
                    ) : ""}
                </div>
            </div>
        </div>
    );
}
